import { publicEventPath, publicPagePath } from '@seiri/shared/common'

export const entityPublicUrl = (slug: string | null | undefined): string => {
  return slug ? `${window.location.origin}${publicPagePath(slug)}` : ''
}

/** The link to one termín on the premise's public page, which opens its sign-up step (docs/public-page.md). */
export const entityPublicEventUrl = (slug: string, eventId: string): string =>
  `${window.location.origin}${publicEventPath(slug, eventId)}`
